module.exports = __webpack_public_path__ + "static/media/Andrew-Photo-Cropped.e950cb73.jpg";